import { WinCodeCard } from "@sidelinesports/fan-design-system";
import type { ApiEndMessageCodeInfo } from "../../../../api";
import { ExternalAnchorLink } from "../../../../components";
import styles from "./PostGameMessage.module.css";

/**
 * Renders a participant's won prize code. URL-format codes render as a clickable
 * external link; alphanumeric and barcode codes render via the design-system
 * `WinCodeCard` (whose `format` prop does not include "url").
 */
export const WinCode = ({ codeInfo }: { codeInfo: ApiEndMessageCodeInfo }) => {
  if (!codeInfo.code) {
    return null;
  }

  if (codeInfo.codeType === "url") {
    // Defense in depth: codes are validated as http(s) on creation, but never
    // render a link for anything else (e.g. a "javascript:" URL) that might
    // predate that validation.
    if (!/^https?:/i.test(codeInfo.code)) {
      return null;
    }
    return (
      <section
        className={`${styles["win-code-box"]} ${styles["url-code-card"]}`}
        aria-label={`Win code: ${codeInfo.code}`}
      >
        <span className={styles["url-code-label"]}>Win code</span>
        <ExternalAnchorLink href={codeInfo.code}>
          {codeInfo.code}
        </ExternalAnchorLink>
      </section>
    );
  }

  return (
    <WinCodeCard
      className={styles["win-code-box"]}
      code={codeInfo.code}
      format={codeInfo.codeType}
      barcodeFormat={codeInfo.barcodeType || undefined}
    />
  );
};
